<template>
<div id="customaddresssetup">
  <v-app id="customaddressappsetup">
    <v-row justify="center">
      <v-dialog v-model="dialog" content-class="info-dialog">
        <v-card>
          <v-card-title>
            <h4>{{$t('custom_address')}}</h4>
          </v-card-title>
          <v-card-text>
            <v-row > 
              <v-col  cols="12" class="minimap">
                <img :src=this.staticURL>
                <div class="minipointer"><v-img  src="@/assets/images/marker.svg"  height="30" contain></v-img></div>
              </v-col>
            </v-row>
            <v-row > 
              <!-- <v-col  cols="12" class="pb-0 subtitle-1"><b></b></v-col> -->
              <v-col  cols="12" class="pb-0"><br>
                 <v-text-field
                  v-model="address"
                  :rules="[rules.required]"
                   v-bind:label="$t('custom_address_add')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="save">{{$t('save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Customaddresssetup',
  data () {
    return {
      dialog: false,
      address: '',
      staticURL:'',
      rules: {
          required: value => !!value || this.$t('mandatory') 
      },
    }
  },
  props: [ 'setCustomPosition' ],
  computed: {
  },
  methods: {
    showInfo(){
        this.setCustomPosition()
    },
    back() {
      return true
    },
    openDialog(){
      this.dialog = true
      this.address = ''
      this.staticURL = 'https://api.mapbox.com/styles/v1/notil/ck7np2rrb0mg41imkry1w1o2o/static/'+this.$store.position[0]+','+this.$store.position[1]+',15/400x200?access_token=pk.eyJ1Ijoibm90aWwiLCJhIjoiY2p2MmhjenhkMTNibzN6a2N1cWRzZmYyciJ9.OJOYbGff0Z2qUSx5jCn5eQ'
    },
    closeDialog(){
      this.dialog = false
      this.address = ''
    },
    save(){
      var data = {}      
      data['token'] = this.$store.userToken
      data['address'] = this.address
      data['lng'] = this.$store.position[0]
      data['lat'] = this.$store.position[1]
      axios.post(this.$store.backendAPI+'newaddress/', data)
      .then(response => {
        if (response.status == 200){

        this.$store.searchedAddress = this.address
        this.$store.searchedAddressText = this.address
         this.showInfo()
        }

      })
      .catch(e => {
        console.log(e)         
      })

    }
  }

}
</script>

